import { cn } from '@/lib/utils';
import type { VehicleListing } from '@/models/types';
import { Button } from '../../ui/button';
import { VEHICLE_HISTORY_OPTIONS_MAP } from './vehicle-history-selector';

export const VehicleHistoryBadge = ({
  value,
  hideCopy = false,
  buttonRef,
  className,
  buttonVariant = 'ghost',
}: {
  value: VehicleListing['vehicle_history'];
  hideCopy?: boolean;
  buttonRef?: React.RefObject<HTMLButtonElement | null>;
  className?: string;
  buttonVariant?: 'outline' | 'ghost';
}) => {
  const option = VEHICLE_HISTORY_OPTIONS_MAP.find(
    (option) => option.value === value,
  );

  return (
    <Button
      variant={buttonVariant}
      className={cn('p-1 h-fit', className)}
      ref={buttonRef}
    >
      {option?.icon}
      {!hideCopy && (
        <p className="rounded text-xs  text-gray-600">
          {
            VEHICLE_HISTORY_OPTIONS_MAP.find((option) => option.value === value)
              ?.label
          }
        </p>
      )}
    </Button>
  );
};
